(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_nova-true-fit"] && !Shopify.designMode) return;
  try {
    (function (r, e) {
    var w = window,
      d = document,
      t,
      s,
      x;
    w.tfcapi = t =
      w.tfcapi ||
      function () {
        t.q = t.q || [];
        t.q.push(arguments);
      };
    t('init', { storeKey: r, environment: e });
    x = d.getElementsByTagName('script')[0];
    s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.crossorigin = 'anonymous';
    s.src = 'https://cdn.truefitcorp.com/fitrec/global/js/tf-integration.js?storeKey=' + r;
    x.parentNode.insertBefore(s, x);
  })('jow', 'prod');

  if (Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', () => {
      new MutationObserver(() => tfcapi('calculate')).observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  (function () {
    var lastKnownLocale = null;

    function fixTrueFit() {
      var placement = document.querySelector('.tfc-fitrec-product');
      if (!placement) return;

      // A color swatch can swap to a different linked product (data-connected-product-url),
      // which rewrites the URL via history.replaceState -- but that URL is often missing the
      // locale prefix (same Weglot origin-fetch race as JR-31891/31952/31974/31992), so re-derive
      // from the URL when possible but fall back to the last known-good locale otherwise, rather
      // than reverting to the stale English value baked into the freshly morphed HTML.
      var match = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(?:\/|$)/i);
      var locale = match ? match[1].toLowerCase() + '_' + match[2].toUpperCase() : lastKnownLocale;

      if (locale) {
        placement.setAttribute('data-locale', locale);
        lastKnownLocale = locale;
      }

      tfcapi('calculate');
    }

    fixTrueFit();

    // Color swatches on this PDP can link to a DIFFERENT product (see nova-swatch.liquid /
    // data-connected-product-url), which morphs <main> (nova-variant-picker.js updateMain)
    // instead of dispatching variant:update -- listen for the custom event fired there.
    document.addEventListener('nova:main-morphed', fixTrueFit);
  })();

  (function observeCartChanges() {
    // JR / Noibu #42: True Fit validates the getToken callback against a schema that
    // requires it to return void. An `async` callback returns a Promise, so the SDK
    // rejected it ("expected void, received Promise") BEFORE running the body -- which
    // meant the _tfcToken cart attribute was never written and True Fit lost the link
    // between the fit recommendation and the resulting order. Keep the callback itself
    // synchronous and run the awaited work inside it.
    const sendTokenToCart = async (token) => {
      if (!token) {
        await fetch('https://setup.truefit.com/api/public/track/', {
          method: 'POST',
          keepalive: true,
          body: JSON.stringify({
            additionalInfo: { shop: window.Shopify.shop },
            type: 'emptyTfcToken',
            level: 'info',
            timestamp: new Date().toISOString(),
          }),
          headers: { 'Content-Type': 'application/json' },
        });
        return;
      }
      const formData = new FormData();
      formData.append('attributes[_tfcToken]', token);
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        keepalive: true,
        body: formData,
      });
    };

    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\/add/.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          tfcapi('getToken', (token) => {
            // Returns undefined, not a Promise -- this is what satisfies True Fit's check.
            sendTokenToCart(token).catch((error) => {
              console.warn('True Fit: could not attach _tfcToken to the cart.', error);
            });
          });
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_video-block"] && !Shopify.designMode) return;
  try {
    class VimeoVideoBlock extends HTMLElement {
    connectedCallback() {
      var self = this;
      var toggleBtn = this.querySelector('[data-vimeo-toggle]');
      if (!toggleBtn) return;

      var isPlaying = false;

      function getIframe() {
        return self.querySelector('iframe.js-vimeo');
      }

      function vimeoPost(method) {
        var iframe = getIframe();
        if (iframe) iframe.contentWindow.postMessage(JSON.stringify({ method: method }), '*');
      }

      function updateIcons(playing) {
        var playIcon = toggleBtn.querySelector('.icon-play');
        var pauseIcon = toggleBtn.querySelector('.icon-pause');
        if (playIcon) playIcon.classList.toggle('hidden', playing);
        if (pauseIcon) pauseIcon.classList.toggle('hidden', !playing);
      }

      function showToggle() {
        if (!toggleBtn.classList.contains('hidden')) return;
        toggleBtn.classList.remove('hidden');
        isPlaying = true;
        updateIcons(true);
      }

      // Autoplay: iframe already in DOM when element connects
      if (getIframe()) showToggle();

      // Click-to-play: watch poster button for deferred-media__playing class
      var posterBtn = this.querySelector('.deferred-media__poster-button:not([data-vimeo-toggle])');
      if (posterBtn) {
        new MutationObserver(function () {
          if (posterBtn.classList.contains('deferred-media__playing')) showToggle();
        }).observe(posterBtn, { attributes: true, attributeFilter: ['class'] });
      }

      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        vimeoPost(isPlaying ? 'pause' : 'play');
        isPlaying = !isPlaying;
        updateIcons(isPlaying);
      });
    }
  }

  if (!customElements.get('vimeo-video-block')) {
    customElements.define('vimeo-video-block', VimeoVideoBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nova-klarna-osm"] && !Shopify.designMode) return;
  try {
    var KLARNA_SUPPORTED_LOCALES = [
    'en-AT', 'de-AT',
    'nl-BE', 'en-BE', 'fr-BE',
    'en-CH', 'de-CH', 'it-CH', 'fr-CH',
    'en-CZ', 'cs-CZ',
    'de-DE', 'en-DE',
    'da-DK', 'en-DK',
    'es-ES', 'en-ES',
    'fi-FI', 'sv-FI', 'en-FI',
    'fr-FR', 'en-FR',
    'en-GB',
    'en-GR', 'el-GR',
    'en-HU', 'hu-HU',
    'en-IE',
    'en-IT', 'it-IT',
    'nl-NL', 'en-NL',
    'no-NO', 'nb-NO', 'en-NO',
    'en-PL', 'pl-PL',
    'en-PT', 'pt-PT',
    'en-RO', 'ro-RO',
    'sv-SE', 'en-SE',
    'sk-SK', 'en-SK',
    'en-CA', 'fr-CA',
    'es-MX', 'en-MX',
    'en-US', 'es-US',
    'en-AU', 'en-NZ',
  ];

  class NovaKlarnaOsm extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('klarna-placement')) return;
      this._listenVariantUpdate();
      this._injectShadowStyles();
      this._fixLocale();
    }

    _fixLocale() {
      var match = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(?:\/|$)/i);
      if (!match) return;

      var country = match[2].toUpperCase();
      var locale = match[1].toLowerCase() + '-' + country;
      if (KLARNA_SUPPORTED_LOCALES.indexOf(locale) === -1) {
        var enFallback = 'en-' + country;
        if (KLARNA_SUPPORTED_LOCALES.indexOf(enFallback) === -1) return;
        locale = enFallback;
      }

      var placement = this.querySelector('klarna-placement');
      placement.setAttribute('data-locale', locale);

      if (window.KlarnaOnsiteService) {
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      } else {
        document.addEventListener(
          'nova:klarna-sdk-loaded',
          function () {
            if (window.KlarnaOnsiteService) {
              window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
            }
          },
          { once: true }
        );
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this._onVariantUpdate);
      if (this._shadowObserver) this._shadowObserver.disconnect();
    }

    _listenVariantUpdate() {
      this._onVariantUpdate = function (e) {
        var variant = e.detail && e.detail.resource;
        if (!variant || !variant.price) return;
        var placement = this.querySelector('klarna-placement');
        if (placement) placement.setAttribute('data-purchase-amount', variant.price);
        if (window.KlarnaOnsiteService) {
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
      }.bind(this);
      document.addEventListener('variant:update', this._onVariantUpdate);
    }

    _injectShadowStyles() {
      var placement = this.querySelector('klarna-placement');
      if (!placement) return;

      var doInject = function () {
        var sr = placement.shadowRoot;
        if (!sr || !sr.querySelector('.container')) return false;
        if (sr.getElementById('nova-klarna-styles')) return true;
        var style = document.createElement('style');
        style.id = 'nova-klarna-styles';
        style.textContent =
          '.container { border: none !important; padding: 0 !important; background-color: transparent !important; }';
        sr.appendChild(style);
        return true;
      }.bind(this);

      if (!doInject()) {
        this._shadowObserver = new MutationObserver(
          function () {
            if (doInject()) this._shadowObserver.disconnect();
          }.bind(this)
        );
        this._shadowObserver.observe(placement, { childList: true, subtree: true });
      }
    }
  }

  if (!customElements.get('nova-klarna-osm')) {
    customElements.define('nova-klarna-osm', NovaKlarnaOsm);
  }
  } catch(e) { console.error(e); }
})();

})();
